module.exports = __webpack_public_path__ + "static/media/main-stage-1.8adcb66c.png";